import React from 'react';

import { Input, InputGroup, Icon, Button} from 'rsuite';
import { Form } from 'antd';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetTable from '../../widget/WidgetTable';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetSelect from '../../widget/WidgetSelect';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetModal from '../../widget/WidgetModal';

import 'antd/dist/antd.css';

class Method extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        this.state = {
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            allDataOptions : {
                // 数据条数
                records : 15,
                checkedKey: "id",
                check: {name:"id"}

                // records: 15,
                // rowKey: "id",
                // isAutoHeight: true,
                // checkedKey: "id",
                // check: true,
            },
            options : {
                // 数据条数
                records : 15,
                checkedKey: "id",
                check: {name:"id"}
            },
            allDataColumns:[
                { name: 'id', title: '组件id', type: 'string', description: '组件id', properties: { hidden: true }},
                // { name: 'parent_id', title: '父组件id', type: 'string', description: '父组件id', properties: { hidden: true }},
                { name: 'title', title: '接口标题', type: 'string', description: '接口标题', properties: { hidden: false }},
                { name: 'name', title: '接口名称', type: 'string', description: '接口名称', properties: { hidden: false }},
                { name: 'type', title: '接口类型', type: 'string', description: '接口类型', properties: { hidden: false }},
                { name: 'description', title: '接口描述', type: 'string', description: '接口描述', properties: { hidden: false }},
                // { name: 'operation', title: '操作', type: 'string', description: '操作', 
                //     properties: {hidden: false, 
                //         operations: [
                //             { name: '编辑', click: "compile" }
                //         ]
                //     }
                // },
              
            ],
            columns:[
                { name: 'id', title: '组件id', type: 'string', description: '组件id', properties: { hidden: true }},
                { name: 'parent_id', title: '父组件id', type: 'string', description: '父组件id', properties: { hidden: true }},
                { name: 'title', title: '组件标题', type: 'string', description: '组件标题', properties: { hidden: false }},
                { name: 'name', title: '组件名称', type: 'string', description: '组件名称', properties: { hidden: false }},
                { name: 'type', title: '组件类型', type: 'string', description: '组件类型', properties: { hidden: false }},
                { name: 'description', title: '关联接口', type: 'string', description: '关联接口', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            { name: '删除', click: "remove" }
                        ]
                    }
                },
              
            ],
            adddata :[],
            editRroupModelOptions : {
                title : "新增组件",
                confirm : "确定",
                size:'md'
            },
            Group : {},
            removeGroup : {},
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : {
                title : "信息",
            },
            typeOptions:{
                title:'组件类型'
            },

            typeData:[
                {"label":"USER", "value":"USER"},
                {"label":"SYSTEM", "value":"SYSTEM"},
                {"label":"SECURITY", "value":"SECURITY"},
                {"label":"WIDGET", "value":"WIDGET"},
                {"label":"SERVICE", "value":"SERVICE"}
            ],
            
            typesData:[
                {"label":"USER", "value":"USER"},
                {"label":"SYSTEM", "value":"SYSTEM"},
                {"label":"SECURITY", "value":"SECURITY"},
                {"label":"WIDGET", "value":"WIDGET"},
                {"label":"SERVICE", "value":"SERVICE"}
            ],

            defaultValue : 3,
            addComponentMethods : {
                title : "添加组件对应接口关系",
                confirm : "确定",
                size:'lg'
            },
            removeData:{},
            beforeComponentData:undefined,
            checkKeys:[],
            dataChecks:[],
            searchWord:undefined,
        };
        

        this.onEvent = this.onEvent.bind(this);
        this.addMethods=this.addMethods.bind(this)
        this.pageTurning = this.pageTurning.bind(this);
        this.createComponent = this.createComponent.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.loadComponentMetheds = this.loadComponentMetheds.bind(this);
        this.onLoadComponentMetheds = this.onLoadComponentMetheds.bind(this);
        this.allDataTableOnCheck = this.allDataTableOnCheck.bind(this);
        this.allDataPageTurning = this.allDataPageTurning.bind(this);
        this.addComponentMethods = this.addComponentMethods.bind(this);
        this.onAddComponentMethods = this.onAddComponentMethods.bind(this);
        this.removeComponentMethod = this.removeComponentMethod.bind(this);
        this.onRemoveComponentMethod = this.onRemoveComponentMethod.bind(this);
        this.searchMethod = this.searchMethod.bind(this);
        this.onsearchMethod = this.onsearchMethod.bind(this);
        this.backParentPage = this.backParentPage.bind(this);
        this.removeCheckData = this.removeCheckData.bind(this);
        this.dataTableOnCheck = this.dataTableOnCheck.bind(this);
        this.onRemoveCheckData = this.onRemoveCheckData.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.searchKeyWord = this.searchKeyWord.bind(this)
    }

    componentDidMount()
    {
        this.searchMethod(1)
        this.setState({beforeComponentData:this.props.history.location.state.department},()=>{
            this.loadComponentMetheds()
        })
    }

    //请求已经添加进组件的接口
    loadComponentMetheds( page )
    {
        let { path, beforeComponentData, allDataOptions } = this.state,params;
        
        if(page===undefined)
        {
            page = 1
        }
        params = {
            id:beforeComponentData.id,
            records:allDataOptions.records,
            page
        };

        WidgetAjax.ajax({url:path + 'component/search_method', params:params, callback:this.onLoadComponentMetheds});
    }

    onLoadComponentMetheds(result)
    {
        if(result.status===0)
        {
            this.setState({data:result.results,total:result.total})
        }  
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }


    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
    addComponent = (ref) => {

        this.addComponent =  ref ;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    caddPropety = (ref) => {
        this.caddPropety=ref
    }

    /**
     * 已添加的表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
     onEvent(type, data, value, event)
     {
         if( data!==undefined )
         {
             data = JSON.parse(data);
         }
 
         switch( type )
         {
             case "remove":
             {
                 this.setState({removeData:data},()=>{
                    this.removeComponentMethod()
                 })
                 break;
             }
             default:
                 break;
         }
     }

    removeMethod()
    {
        let { messageOptions, removeData } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要删除组件对应关系 '` + removeData.name +`' 吗? 删除后将不能恢复！` ;
        messageOptions["confirmFunction"] = this.removeComponentMethod;

        this.state["messageOptions"] = messageOptions;
        this.messageRef.open()
    }

    removeComponentMethod( id = undefined )
    {
        let { path, removeData, beforeComponentData, messageOptions } = this.state;
        let params = {
                id:beforeComponentData.id,
                method_id:id === undefined?removeData.id:id
            };
        WidgetAjax.ajax({url:path + 'component/remove_method', params:params, callback:this.onRemoveComponentMethod});
    }

    onRemoveComponentMethod( result )
    {
        let { messageOptions } = this.state;
        if(result.status === 0)
        {
            messageOptions["isMessage"] = true;
            messageOptions["title"] = "删除成功";
            messageOptions["message"] = "删除组件对应关系成功!" ;
            this.setState({messageOptions},()=>{this.messageRef.open()})
            this.props.history.go()
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 添加接口关系表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
     onAllDataEvent(type, data, value, event)
     {
         if( data!==undefined )
         {
             data = JSON.parse(data);
         }
 
         switch( type )
         {
             case "compile":
             {
                 this.setState({editData:data})
                 this.addComponent.open();
                 break;
             }
             default:
                 break;
         }
     }


    /**
     * 创建角色
     */
    createComponent()
    {
        this.state["isCreate"] = true;

        this.setState({Group:{}, RroupId:undefined,searchWord:undefined });

        this.addComponent.open();
    }

    /**
     * 确认添加接口对应关系
     */
    addMethods()
    {
        let { checkKeys, data } = this.state,arr=[];

        checkKeys.forEach((val)=>{
            data.forEach((item)=>{
                if(val.id === item.id)
                {
                    console.log(val,"已经存在")
                }
                else
                {
                    
                }
            })
            this.addComponentMethods(val.id)
        })

        this.setState({checkKeys:[]},()=>this.loadComponentMetheds())

        setTimeout(()=>{
            window.location.reload();
        },100)
        
    }

    /**
     * 添加接口对应关系函数
     * @param {*} id 
     */
    addComponentMethods( id )
    {

        let { path, beforeComponentData } = this.state,
            params = {
                id:beforeComponentData.id,
                method_id:id
            };

        WidgetAjax.ajax({url:path + 'component/add_method', params:params, callback:this.onAddComponentMethods});
    }

    onAddComponentMethods(result)
    {
        if(result === 0)
        {
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }


    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange( value,type)
    {
        switch( type )
        {
            case "keyword":
            {
                this.setState({keyWord:value});
                this.searchMethod()
                break;
            }

            case "keywords":
            {
                if(value === "" || value === null || value === undefined)
                {
                    this.setState({keyWord:value},()=>{
                        this.searchMethod()
                    });
                }
                else
                {
                    this.setState({keyWord:value});
                }
                break;
            }
             
            default:
                break;
        }
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
       {
            this.searchMethod();
       }    
    }

    /**
     * 组件搜索函数
     */
    searchMethod(page)
    {
        const { path, keyWord,allDataOptions,searchWord } =this.state;
        if(page===undefined)
        {
            page = 1
        }

        let params= {
            page:page,
            records : allDataOptions.records
        }
        
        if(searchWord!==undefined)
        {
            params['name'] = searchWord
        }
        WidgetAjax.ajax({url:path+'method/search', params:params, callback:this.onsearchMethod})
        this.setState({page:page})
    }

    onsearchMethod(result,params)
    {
        // let {data} = this.state,allData=[];
        if(result.status===0)
        {
            // for(let item of result.results)
            // {
            //     for(let items of data)
            //     {
            //         if(item !== items){
            //             allData.push(item)
            //         }
            //     }
            // }
            this.setState({allData:result.results,allTotal:result.total})
        }   
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }
    
        /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.loadComponentMetheds(page);
    }

    allDataPageTurning( page )
    {
        this.searchMethod(page);
    }

    allDataTableOnCheck(data)
    {
        this.setState({checkKeys:data})
    }

    dataTableOnCheck( data )
    {
        this.setState({dataChecks:data})
    }

    backParentPage()
    {
        this.props.history.push({pathname:'/home/component'});
    }

    removeCheckData()
    {

        let { messageOptions, removeData, dataChecks } = this.state;

        if(dataChecks.length === 0)
        {

            messageOptions["isMessage"] = true ;
            messageOptions["message"] = `请先选择要删除的接口对应关系` ;
    
            this.state["messageOptions"] = messageOptions;
            this.messageRef.open()
        }
        else
        {
            let removeNames = "",isFirst = true;
            dataChecks.forEach((item,index)=>{
                if( index === dataChecks.length - 1 || isFirst)
                {
                    removeNames += item.title;
                    isFirst = false
                }
                else
                {
                    removeNames =  removeNames + ", " + item.title
                }
            })
            messageOptions["isMessage"] = false ;
            messageOptions["message"] = `确定要删除组件对应关系 '` + removeNames +`' 吗? 删除后将不能恢复！` ;
            messageOptions["confirmFunction"] = this.onRemoveCheckData;

            this.state["messageOptions"] = messageOptions;
            this.messageRef.open()
        }

    }

    onRemoveCheckData()
    {
        let { dataChecks } = this.state;
        dataChecks.forEach((item,index)=>{
            if(index === dataChecks.length-1)
            {
                this.removeComponentMethod(item.id);
            }
            else
            {
                this.removeComponentMethod(item.id);
            }
        })
    }

     searchKeyWord(value)
     {
        this.setState({searchWord:value})
        // this.state["searchWord"] = value
     }

    render()
    {
        const { columns, data, total, keyWord, options, editRroupModelOptions, messageOptions, typeOptions,typeData, defaultValue,
                addComponentMethods, editData, allData, allTotal, allDataOptions, allDataColumns, checkKeys, beforeComponentData,
                dataChecks,searchWord,page} = this.state;

        // editRroupModelOptions["confirmFunction"] = this.submitComponent;
        addComponentMethods["confirmFunction"] = this.addMethods;
        return (
            <div className="page">
                {/* <div className="page-weidu">
                    <div className="page-title">
                        <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font">组件接口对应关系</span>
                    </div>
                </div> */}
                
                <div className="page-content page-overflow"  style={{height:"100%"}}>
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-title Addroles component-type"  style={{padding:"0 16px"}}>
                            {/* <WidgetSelect defaultValue={defaultValue} onSelect={this.onSelect} options={typeOptions}  data={typeData}></WidgetSelect> */}
                            <div onClick={this.backParentPage} className='click'>
                                <img src={require('./img/icon/goback.svg')} />
                                <span style={{marginLeft:"10px"}}>{this.props.history.location.state.department.title+"组件接口对应关系"}</span>
                            </div>
                            
                        
                            <div className="search" style={{width:"auto"}}>
                                {/* <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey"  defaultValue={keyWord} placeholder="请输入搜索内容" onChange={(value)=>(this.keyWordOnChange(value,'keywords'))} onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" /></InputGroup.Addon>
                                </InputGroup> */}
                                <div className="button btnleft" onClick={this.removeCheckData} style={{margin:"0 20px",background:"#D9492E"}}>
                                    <span>批量删除</span>
                                </div>
                                <div className="button btnleft" onClick={this.createComponent} style={{margin:"0"}}>
                                    <span>添加接口</span>
                                </div>
                            </div>
                        </div>

                        <div className="content-chart-height content-table">
                            <WidgetTable options={options} columns={columns} data={data} total={total} 
                                         notify={this.onEvent} pageTurning={this.pageTurning} allDataHeight={"750px"} checkKeys={dataChecks} onCheck={this.dataTableOnCheck}></WidgetTable>
                        </div>
                    </div>
                    <WidgetMessage options={messageOptions} onRef={this.messageRef} />
                </div>
                <WidgetModal options={addComponentMethods} onRef={this.addComponent}>
                    <div>
                    <div className="searchWord"  >
                        <Input defaultValue={searchWord} placeholder={"请输入"} onChange={(value) => {this.searchKeyWord(value)}} onKeyUp={this.keyWordKeyUp}></Input>
                    </div>
                        <WidgetTable options={allDataOptions} columns={allDataColumns} data={allData} onCheck={this.allDataTableOnCheck} 
                                 total={allTotal} notify={this.onAllDataEvent}  pageTurning={this.allDataPageTurning}></WidgetTable>
                    </div>
                </WidgetModal>
          </div>
        );
    }
}


export default Method
